<template>
    <div>
        <h3 class="text-lg font-medium text-gray-900">Browser Sessions</h3>
        <p class="mt-1 text-sm text-gray-600">
            Manage and log out your active sessions on other browsers and devices.
        </p>
        
        <div class="mt-5 space-y-6">
            <!-- Session List Placeholder -->
            <div class="flex items-center">
                <div>
                    <div class="flex items-center">
                        <svg class="w-8 h-8 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                        </svg>
                        <div class="ml-3">
                            <div class="text-sm font-medium text-gray-900">
                                This device
                            </div>
                            <div class="text-sm text-gray-500">
                                Current session
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Logout Other Sessions Button -->
            <div class="flex items-center justify-between">
                <button
                    type="button"
                    class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 transition"
                >
                    Log Out Other Browser Sessions
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LogoutOtherBrowserSessionsForm'
}
</script>